import { createContext, useContext } from 'react';
import type { Me, Role } from './api.ts';
import type { AppConfig } from './auth.ts';

export interface Session {
  config: AppConfig;
  me: Me;
  has: (...roles: Role[]) => boolean;
  isAdmin: boolean;
  /** Called after the dev identity changes; reloads /api/me and reconnects the stream. */
  reload: () => void;
}

export const SessionContext = createContext<Session | null>(null);

export function useSession(): Session {
  const s = useContext(SessionContext);
  if (!s) throw new Error('useSession outside SessionContext');
  return s;
}

export function makeSession(config: AppConfig, me: Me, reload: () => void): Session {
  const has = (...roles: Role[]) => roles.some((r) => me.roles.includes(r));
  return { config, me, has, isAdmin: me.roles.includes('admin'), reload };
}
